import { PILL, DEFAULT } from 'conversations-internal-schema/widget-data/constants/launcherTypes';
export const getUsePillLauncher = ({
  isAIChatBot,
  launcherType
}) => isAIChatBot && (launcherType === PILL || launcherType === DEFAULT);
export const getShowPillLauncher = ({
  isAIChatBot,
  launcherType,
  mobile
}) => getUsePillLauncher({
  isAIChatBot,
  launcherType
}) && !mobile;